/**
 * Fonction servant à récupérer le role des utilisateurs et les trier par profil
 *
 * (étudiant / alumni)
 *
 * @param {Object[]} usersRolesCount - Données des utilisateurs par role
 * @param {string} usersRolesCount[].roleName - Nom du role
 * @param {number} usersRolesCount[].userCount - Nombre d'utilisateurs par role
 *
 * @returns {NivoPieChartData}  données formatées pour Nivo
 */
export const getUsersRolesData = (usersRolesCount) => {
  // Création d'un objet pour stocker le nombre d'utilisateurs par role : {role : nombre}
  let usersRoles = {};

  // Création de deux clés correspondants aux roles voulus : étudiant / alumni
  usersRoles["Étudiants"] = 0;
  usersRoles["Alumni"] = 0;

  // Pour chaque role récupéré, on incrémente le nombre d'utilisateurs correspondant au role
  usersRolesCount.forEach((role) => {
    if (role && role?.roleName && role.roleName?.includes("ROLE_ETUDIANT")) {
      usersRoles["Étudiants"] += role.userCount;
    } else if (role?.roleName == "ROLE_ALUMNI") {
      usersRoles["Alumni"] += role.userCount;
    }
  });

  const chartData = [];

  // On return les données correctement pour ChartJS
  Object.keys(usersRoles).forEach((key) => {
    chartData.push({
      label: key,
      id: key,
      value: usersRoles[key],
    });
  });

  return chartData;
};
